module.exports = __webpack_public_path__ + "img/sol_isol_pain2.3abb12a8.png";